import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { supabase } from "../supabase";

const navItems = [
  { label: "Dashboard", path: "/" },
  { label: "Drivers", path: "/drivers" },
  { label: "Contracts", path: "/contracts" },
  { label: "Analytics", path: "/analytics" },
  { label: "Team", path: "/team" },
  { label: "Settings", path: "/settings" },
];

export default function MobileHeader({ title }) {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    await supabase.auth.signOut();
    navigate("/login");
  };

  return (
    <>
      {/* Mobile top bar */}
      <div
        style={{
          background: "#2c2c2c",
          padding: "14px 16px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          position: "sticky",
          top: 0,
          zIndex: 100,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <img
            src="/Icon.png"
            alt="Porso"
            style={{
              height: "28px",
              width: "28px",
              objectFit: "contain",
              borderRadius: "5px",
            }}
          />
          <div style={{ color: "#fff", fontSize: "14px", fontWeight: "500" }}>
            Porso Freight
          </div>
        </div>

        {/* Hamburger button */}
        <button
          onClick={() => setOpen(!open)}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: "4px",
            display: "flex",
            flexDirection: "column",
            gap: "5px",
          }}
        >
          <div
            style={{
              width: "22px",
              height: "2px",
              background: open ? "#3a9e5f" : "#888",
              borderRadius: "2px",
              transition: "all 0.2s",
            }}
          />
          <div
            style={{
              width: "22px",
              height: "2px",
              background: open ? "#3a9e5f" : "#888",
              borderRadius: "2px",
              transition: "all 0.2s",
            }}
          />
          <div
            style={{
              width: "22px",
              height: "2px",
              background: open ? "#3a9e5f" : "#888",
              borderRadius: "2px",
              transition: "all 0.2s",
            }}
          />
        </button>
      </div>

      {/* Dropdown menu */}
      {open && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 99,
            background: "rgba(0,0,0,0.5)",
          }}
          onClick={() => setOpen(false)}
        >
          <div
            style={{
              background: "#2c2c2c",
              paddingTop: "70px",
              width: "240px",
              height: "100%",
              position: "absolute",
              left: 0,
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                padding: "0 16px 8px",
                fontSize: "10px",
                color: "#666",
                textTransform: "uppercase",
                letterSpacing: "0.8px",
              }}
            >
              Main
            </div>
            {navItems.map((item) => {
              const active = location.pathname === item.path;
              return (
                <button
                  key={item.path}
                  onClick={() => {
                    navigate(item.path);
                    setOpen(false);
                  }}
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    padding: "12px 16px",
                    fontSize: "14px",
                    background: active ? "#363636" : "transparent",
                    color: active ? "#fff" : "#999",
                    border: "none",
                    borderLeft: active
                      ? "2px solid #3a9e5f"
                      : "2px solid transparent",
                    cursor: "pointer",
                    textAlign: "left",
                  }}
                >
                  {item.label}
                </button>
              );
            })}

            <div
              style={{
                padding: "20px 16px 0",
                borderTop: "1px solid #383838",
                marginTop: "16px",
              }}
            >
              <button
                onClick={handleLogout}
                style={{
                  fontSize: "13px",
                  color: "#666",
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                Sign out
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
